import classNames from 'classnames/bind';
import React from 'react';
import styles from './Unauthorized.module.scss';

const cx = classNames.bind(styles);

const Unauthorized = (): React.ReactElement => {
  return (
    <div className={cx('body')}>
      <div className={cx('text-box')}>
        <h1 className={cx('header')}>Oops!</h1>
        <span className={cx('info-message')}>
          There was an issue logging you in. Our team has been notified and will be in touch.
        </span>
      </div>
    </div>
  );
};

export default Unauthorized;
